export default __webpack_public_path__ + "static/ambassador-logo-e6affe1d34a44fe681b734f367b1b6e0.svg";